import React, { useEffect } from 'react';
import axios from './API';
import { useDispatch } from 'react-redux';
import { logoutUser } from '../store/appStore/actions/userActions'
import { toast } from 'react-toastify';
import AlertSimple from '../components/alert/AlertSimple'
import * as palette from '../style/Variables';

const TOKEN_EXPIRED_MESSAGE = 'TokenExpiredError: jwt expired'

// Registers a single axios response interceptor for the lifetime of the app
// (registered once in an effect and ejected on unmount, so re-renders do not
// stack handlers). Any 401, or the backend's explicit token-expired message,
// logs the user out once. Errors are re-thrown unchanged so callers keep
// error.response, error.message and the rest.
function ResponseInterceptor() {
    const dispatch = useDispatch()

    useEffect(() => {
        let logoutScheduled = false

        const isHandlerEnabled = (config = {}) => {
            return config.hasOwnProperty('handlerEnabled') && !config.handlerEnabled ? false : true
        }

        const errorHandler = (error) => {
            const response = error && error.response
            if (response && isHandlerEnabled(error.config)) {
                const message = response.data && response.data.message
                const sessionInvalid = response.status === 401 || message === TOKEN_EXPIRED_MESSAGE
                if (sessionInvalid && !logoutScheduled) {
                    logoutScheduled = true
                    toast.error((<AlertSimple icon={palette.x} text='Token expired, please login again!' />), { autoClose: 3000 })
                    setTimeout(() => logoutUser(dispatch), 3000)
                }
            }
            return Promise.reject(error)
        }

        const interceptorId = axios.interceptors.response.use(
            response => response,
            error => errorHandler(error)
        )
        return () => axios.interceptors.response.eject(interceptorId)
    }, [dispatch])

    return null
}

export default ResponseInterceptor;
